import { useTranslation } from 'react-i18next';

import Hr from '../../components/Style/hr';
import SystempayComponent from '../../components/Paiement/systempay';
import TitlePaymentLink from '../../components/title-payment-link';

export default function StepPayment({ formData, returnedData }) {
    const { t } = useTranslation();

    const handleReturnedData = (data) => {
        returnedData(data);
    };

    return (
        <>
            <TitlePaymentLink title={t('pagePaymentLink.step3.welcomeMessage')} description={t('pagePaymentLink.step3.description')} step="3" />
            <Hr />
            <SystempayComponent data={formData} returnedData={handleReturnedData} stepBack="step2" />
        </>
    );
}